import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * TooltipWrapper;
 *  - Wrapper for all Question Components
 */
export function TooltipWrapper(props) {
  const className = `${style.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

TooltipWrapper.propTypes = {
  /**
   * List of components to display in side this.
   */
  children: PropTypes.array,
  /**
   * ClassName for the question wrapper
   */
  className: PropTypes.string,
};

TooltipWrapper.defaultProps = {className: '', children: null};
